<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon
                   v-bind="attrs"
                   v-on="on"
                   x-small
                   class="mr-1 clickable"
                   v-clipboard="text"
                   @success="handleSuccess"
                   @error="handleError"
            >
                <v-icon

                >mdi-content-copy</v-icon>
            </v-btn>

        </template>
        <span>{{$t('copy_to_clipboard')}}</span>
    </v-tooltip>
</template>

<script>
    import { clipboard } from 'vue-clipboards';
    export default {
        directives: {
            clipboard
        },
        props: {
            text: {
                required: true
            }
        },
        methods: {
            handleSuccess() {
                this.$notify({
                    group: 'formGroup',
                    type: 'info',
                    title : this.text,
                    text: this.$t('messages.success_copy_to_clipboard'),
                });
            },
            handleError() {
                this.$notify({
                    group: 'formGroup',
                    type: 'error',
                    title: this.$t('messages.field_copy_to_clipboard'),
                });
            }
        }
    }
</script>